import classNames from "classnames";
import * as React from "react";
import { useLayer } from "react-laag";
import { GlideIcon } from "sharedUI/ui/views/glide-icon/glide-icon";
import tw from "twin.macro";
import { APP_MODAL_ROOT } from "webapp/lib/constants";
import { css } from "webapp/styled-components";
import type { ExtractedAction } from "webapp/wire-renderers/wire-lib";
import type { WireButtonProps } from "../wire-button/wire-button";
import { WireButton } from "../wire-button/wire-button";

interface Props extends Omit<WireButtonProps, "onClick"> {
    readonly menuItems: readonly ExtractedAction[];
}

export const WireMenuButton: React.VFC<Props> = p => {
    const { menuItems, ...rest } = p;

    const [open, setOpen] = React.useState(false);

    const { layerProps, triggerProps, renderLayer } = useLayer({
        isOpen: open,
        auto: true,
        placement: "bottom-end",
        possiblePlacements: ["top-end", "top-start", "bottom-end", "bottom-start"],
        container: APP_MODAL_ROOT,
        triggerOffset: 5,
        onOutsideClick: () => setOpen(false),
    });

    return (
        <WireButton
            data-testid="menu-button"
            {...rest}
            {...triggerProps}
            onClick={e => {
                e.stopPropagation();
                setOpen(cv => !cv);
            }}
            // FIXME this is fucking with other shit
            tw="min-w-min! max-w-min px-2!">
            <GlideIcon tw="mx-auto" icon="mt-dots-horizontal" kind="monotone" iconSize={20} />
            {open &&
                renderLayer(
                    <ul
                        data-testid="mb-dropdown"
                        tw="max-width[300px] min-width[192px] flex flex-col bg-bg-front rounded-lg py-2 shadow-md-dark"
                        {...layerProps}>
                        {menuItems.map(item => (
                            <li
                                data-testid="mb-li"
                                key={item.title}
                                className={classNames({ disabled: !item.enabled })}
                                css={css`
                                    &.disabled {
                                        ${tw`pointer-events-none opacity-50`}
                                    }
                                `}
                                tw="px-3 py-2 cursor-pointer hover:bg-bg-back font-semibold text-sm
                                    focus-visible:underline"
                                onClick={e => {
                                    e.stopPropagation();
                                    if (!item.enabled) return;
                                    setOpen(false);
                                    item.run?.(false);
                                }}>
                                {item.title}
                            </li>
                        ))}
                    </ul>
                )}
        </WireButton>
    );
};
